import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'gatsby';
import Cookies from 'js-cookie';
import EditableWidgetContext from 'utils/EditableWidgetContext';
import queryString from 'query-string';
import { queryStringToCookies } from 'utils/urlHelper';
import pencilIcon from './images/pencil-icon.png';
import optionsIcon from './images/options-icon.png';
import closeIcon from './images/close-icon.png';

import { CloseModal, Container, PageWidget, Widget } from './styles';

const ContentfulEditWidget = ({ isHeader, isHero, isPage, type, id }) => {
  const [isCloseModalOpen, setIsCloseModalOpen] = useState(false);
  const values = useContext(EditableWidgetContext);

  useEffect(() => {
    const params = queryString.parse(window.location.search);
    const cookiePresent = Cookies.get('editable');

    if (params.editable || cookiePresent === 'true') {
      queryStringToCookies();
      values?.updateEditable(true);
    } else {
      values?.updateEditable(false);
    }
  }, []);

  const handleClosePreviewClick = () => {
    setIsCloseModalOpen(false);
    values?.updateEditable(false);
  };

  if (values?.editable && type !== 'ContentfulHeader') {
    return (
      <Container>
        {isPage ? (
          <>
            <PageWidget className="widget" isCloseModalOpen={isCloseModalOpen}>
              <Link
                to={`https://app.contentful.com/spaces/${process.env.GATSBY_CONTENTFUL_SPACE_ID}/environments/master/entries/${id}`}
                target="_blank"
              >
                <p>Edit Page</p>
              </Link>
              <img
                src={optionsIcon}
                className="options-icon"
                onClick={() => setIsCloseModalOpen(true)}
              />
            </PageWidget>
            <CloseModal className={isCloseModalOpen ? 'widget open' : 'widget closed'}>
              <p onClick={() => handleClosePreviewClick()}>Exit Preview</p>
              <img
                src={closeIcon}
                className="options-icon"
                onClick={() => setIsCloseModalOpen(false)}
              />
            </CloseModal>
          </>
        ) : (
          <Widget
            to={`https://app.contentful.com/spaces/${process.env.GATSBY_CONTENTFUL_SPACE_ID}/environments/master/entries/${id}`}
            target="_blank"
            isHeader={isHeader}
            isHero={isHero}
            isPage={isPage}
            className={isPage ? 'widget page-widget' : 'widget'}
          >
            <img src={pencilIcon} className="edit-icon" />
          </Widget>
        )}
      </Container>
    );
  } else {
    return null;
  }
};

export default ContentfulEditWidget;
